export default __webpack_public_path__ + "media/images/wordmark-e55a5e63f45f0ed247977a6f8d381495.png";